import { render, staticRenderFns } from "./ModelVersionBadge.vue?vue&type=template&id=2a44df3e&"
import script from "./ModelVersionBadge.vue?vue&type=script&lang=js&"
export * from "./ModelVersionBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports